import {selector} from 'recoil';

import {filtersServiceRequestsSetsState, triggerFiltersServiceRequestsQuery} from './atoms';

import {FilterService} from '../../api/services/filters.service';

import {authState} from '../auth/atoms';

export const filtersSetsServiceRequestsQuery = selector({
  key: 'filtersSetsServiceRequestsQuery',
  get: async ({get}) => {
    get(triggerFiltersServiceRequestsQuery);
    const {user} = get(authState);

    if (!user) return [];

    const res = await FilterService.getAll(user.id, 'SERVICE_REQUEST');

    return res.data.content.map((item) => ({...item, filters: JSON.parse(item.filters)}));
  },
  set: ({set}, newValue) => {
    newValue && set(filtersServiceRequestsSetsState, newValue);
  },
});
